// extracted by mini-css-extract-plugin
module.exports = {"accordionItem":"accordion_accordionItem__5L0FJ","content":"accordion_content__tcExg","label":"accordion_label__Jo2jC","iconContainer":"accordion_iconContainer__Luq6c"};